"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var CartContext_1 = require("./CartContext");
var ExpressCheckout_1 = require("./ExpressCheckout");
var IntroOfferButton_1 = require("../IntroOffer/IntroOfferButton");
var Guarantee_1 = require("./Guarantee");
var hydrogen_react_1 = require("@shopify/hydrogen-react");
var isNewVisitor = function () {
    var cookie = {};
    //parse through document and push each cookie into array
    document.cookie.split(';').forEach(function (el) {
        var splitCookie = el.split('=');
        var key = splitCookie[0].trim();
        var value = splitCookie[1];
        cookie[key] = value;
    });
    try {
        //extract unix timestamp of ga cookie
        var cookieDate = cookie['_ga'].substring(cookie['_ga'].length - 10);
        var timeDiff = Math.floor(Date.now() / 1000) - parseInt(cookieDate);
        //if time between cookie set and current date is more than 40, they are returning visitor
        return timeDiff < 2400 ? true : false;
    }
    catch (e) {
        console.error(e);
    }
    return true;
};
var OrderSummary = function () {
    var _a = (0, hooks_1.useContext)(CartContext_1.default), allProducts = _a.allProducts, cart = _a.cart, discountThreshold = _a.discountThreshold, freeShipping = _a.freeShipping, introOffer = _a.introOffer, underLimit = _a.underLimit;
    var _b = (0, hooks_1.useState)(window.localStorage.getItem('bannerEnd') == 'true'), bannerEnd = _b[0], setBannerEnd = _b[1];
    var discount = bannerEnd ? '15OFF' : 'NEW25';
    var discountCopy = bannerEnd ? '15% off' : '25% off';
    var multiplier = bannerEnd ? 0.15 : 0.25;
    (0, hooks_1.useEffect)(function () {
        if (!isNewVisitor()) {
            setBannerEnd(true);
        }
    });
    //listen to banner end event from Banner.tsx
    (0, hooks_1.useEffect)(function () {
        window.addEventListener('bannerEnd', function () {
            setBannerEnd(true);
        });
    });
    var subTotal = cart.items_subtotal_price / 100;
    var overallDiscount = 0;
    var percentageDiscountAmount = 0;
    var _loop_1 = function (item) {
        var itemAsProduct = allProducts.find(function (product) { return Number(product.id.split('/')[4]) == item.product_id; });
        // calculation depending on whether item is bundle or not
        if (itemAsProduct) {
            var itemVariantAsProduct = itemAsProduct.variants.nodes.find(function (variant) { return Number(variant.id.split('/')[4]) === item.variant_id; });
            if (itemVariantAsProduct === null || itemVariantAsProduct === void 0 ? void 0 : itemVariantAsProduct.compareAtPrice) {
                overallDiscount =
                    overallDiscount +
                        (Number(itemVariantAsProduct.compareAtPrice.amount) -
                            Number(itemVariantAsProduct.price.amount)) *
                            item.quantity;
            }
        }
        else {
            overallDiscount += item.line_level_total_discount;
        }
    };
    for (var _i = 0, _c = cart.items; _i < _c.length; _i++) {
        var item = _c[_i];
        _loop_1(item);
    }
    if (introOffer) {
        percentageDiscountAmount = subTotal * multiplier;
        subTotal -= percentageDiscountAmount;
        overallDiscount += percentageDiscountAmount;
    }
    return ((0, preact_1.h)("div", { class: "cart-section__summary" },
        (0, preact_1.h)("div", { class: "cart-section__summary-section-one" },
            (0, preact_1.h)("h2", { class: "cart-section__summary-header" }, "Order Summary"),
            discountThreshold && (0, preact_1.h)(IntroOfferButton_1.IntroOfferButton, { discount: discount, discountCopy: discountCopy }),
            (0, preact_1.h)("div", { class: "cart-section__summary-total" },
                (0, preact_1.h)("div", { class: "cart-section__summary-total-subsection" },
                    (0, preact_1.h)("p", { class: "cart-section__summary-total-header" }, "Subtotal"),
                    (0, preact_1.h)("p", { class: "cart-section__summary-total-price" }, (0, hydrogen_react_1.useMoney)({ amount: subTotal.toFixed(2), currencyCode: 'USD' }).localizedString))),
            window.freeShipTest && freeShipping && ((0, preact_1.h)("div", { class: "cart-section__summary-total-subsection" },
                (0, preact_1.h)("p", { class: "cart-section__summary-total-header" }, "Shipping"),
                (0, preact_1.h)("p", { class: "cart-section__summary-total-free-ship" }, "Free")))),
        (0, preact_1.h)("div", { class: "cart-section__summary-section-two" },
            overallDiscount > 0 && ((0, preact_1.h)("p", { class: "cart-section__summary-savings" },
                "YOU'RE SAVING",
                ' ',
                (0, preact_1.h)("span", { class: "cart-section__summary-savings--orange" }, (0, hydrogen_react_1.useMoney)({ amount: overallDiscount.toFixed(2), currencyCode: 'USD' })
                    .localizedString))),
            (0, preact_1.h)("p", { class: "cart-section__summary-shipping-tax" }, "Tax and shipping calculated at checkout"),
            underLimit ? ((0, preact_1.h)(ExpressCheckout_1.default, { price: (0, hydrogen_react_1.useMoney)({ amount: subTotal.toFixed(2), currencyCode: 'USD' }) })) : ((0, preact_1.h)("p", { class: "cart-section__summary-exceed-limit" },
                "If you'd like to place a large order, please reach out to our customer support team at",
                ' ',
                (0, preact_1.h)("a", { href: "mailto:hello@opositiv.com", target: "_blank" }, "hello@opositiv.com"))),
            (0, preact_1.h)(Guarantee_1.default, null))));
};
exports.default = OrderSummary;
